var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearchAsync,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"size":"mini","clearable":""},on:{"select":_vm.onSelect,"clear":_vm.onClear},model:{value:(_vm.major),callback:function ($$v) {_vm.major=$$v},expression:"major"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba19c98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/search/major.vue
// module id = null
// module chunks = 